export default {
    loadData : async function() {
        let listData = require('../assets/weapons/datas/shieldModelDatas.json')
        return listData;
    }
}